// ** React Imports
import React, { ReactNode } from 'react'

// ** Source code Imports
import CookiesPolicy from 'src/views/pages/cookie-policy'
import DocsLayout from 'src/layouts/DocsLayout'

const CookiesPolicyPage = () => {
  return <CookiesPolicy />
}

CookiesPolicyPage.getLayout = (page: ReactNode) => <DocsLayout sx={{ maxWidth: 768, mx: 'auto' }}>{page}</DocsLayout>

CookiesPolicyPage.acl = {
  action: 'read',
  subject: 'cookie-policy-page'
}

export default CookiesPolicyPage
